export default {
  props: {
    level: {
      type: String,
      default: 'success',
    },
  },
  computed: {
    levelModifier() {
      return `alert-box--${this.level}`;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/generics/alert-box/alert-box.js